$(document).ready(function() {
  	var car_selector = $('#car-selector');
  
  	if (car_selector) {
      	var all_products = $('#main-products .product-thumbnail');
      	var wheazi_a = $('#wheazi-1-a');
      	var wheazi_b = $('#wheazi-1-b');
      	var wheazi_c = $('#wheazi-1-c');
      	var car_options = $('#supported-cars a');
      	var mobile_options = $('#car-selector select');
      
      	all_products.hide();
      
      $('#car-selector .input-append a').click(function(){
      	console.log("clicked");
        $('#option-arrow').toggleClass("icon-arrow-down icon-arrow-up");
      });
      
      $('#show-all').click(function(){ 
        	all_products.hide().fadeToggle();  
      	});
      	
      	var cars_s = ['Alfa Romeo', 'Citroën', 'Fiat', 'Peugeot'];
      	var cars_m = ['BMW',  'Lotus', 'Mercedes', 'Mini', 'Opel', 'Renault', 'Saab', 'Tesla', 'Vauxhall'];
      	var cars_l = ['Audi', 'Ferrari', 'Ford', 'MG', 'Porsche', 'Rover', 'Seat', 'Skoda', 'Volvo', 'VW' ];
      	var cars = cars_s.concat(cars_m).concat(cars_l);
      	var car_typeahead = $('#car-selector .typeahead');
      
      car_typeahead.typeahead({
        source: cars
      });
      
      car_typeahead.focus(function(){
      	console.log(car_typeahead.val());
        if (jQuery.inArray(car_typeahead.val(),cars_s) >= 0) { 
          	all_products.hide();
        	wheazi_a.fadeIn(); 
        }
        else if (jQuery.inArray(car_typeahead.val(),cars_m) >= 0) {
          	all_products.hide();
        	wheazi_b.fadeIn();
        }
          else if (jQuery.inArray(car_typeahead.val(),cars_l) >= 0) {
            all_products.hide();
        	wheazi_c.fadeIn();
        }
          
      });
      
      car_options.click(function(e){
        e.preventDefault();
      	var this_option = $(this);
        var target_product = this_option.attr('data-target');
        var to_product = $('#products').offset().top + 330;
        all_products.fadeOut();
        $('#'+target_product).fadeIn();
        $('html, body').animate({
          scrollTop: to_product
        }, 500);
        $('#car-selector .input-append a').click();
      });
      
      mobile_options.change(function(){
        var to_product = $('#products').offset().top + 330;
      	console.log(mobile_options.val());
        if (jQuery.inArray(mobile_options.val(),cars_s) >= 0) { 
          	all_products.hide();
        	wheazi_a.fadeIn();
          	 $('html, body').animate({
          scrollTop: to_product
        }, 500);
        }
        else if (jQuery.inArray(mobile_options.val(),cars_m) >= 0) {
          	all_products.hide();
        	wheazi_b.fadeIn();
           $('html, body').animate({
          scrollTop: to_product
        }, 500);
        }
          else if (jQuery.inArray(mobile_options.val(),cars_l) >= 0) {
            all_products.hide();
        	wheazi_c.fadeIn();
            $('html, body').animate({
          scrollTop: to_product
        }, 500);
        }
          else console.log('error!');
          
      });
      
      /*mobile_options.click(function(){
      	var target_product = $(this).attr('data-target');
        console.log(target_product);
        var to_product = $('#products').offset().top + 330;
        all_products.fadeOut();
        $('#'+target_product).fadeIn();
        $('html, body').animate({
          scrollTop: to_product
        }, 500);
        
      });*/
      
      
      
  	}
  	
  	var buy_btn = $('#buy-me');
  
  	if (buy_btn.length) {
      var btn_trigger = $('#intro').offset().top;
      console.log(btn_trigger);
    
      $(document).resize(function(){
          btn_trigger = $('#intro').offset().top;
      });
      
      var btn_shown = false;
      
      $(window).scroll(function() {
        if ($(window).scrollTop() >= btn_trigger && btn_shown == false) {
          console.log('Show!');
          buy_btn.slideDown(200);
          btn_shown = true;
        }
        if ($(window).scrollTop() < btn_trigger && btn_shown == true){
          buy_btn.slideUp(200);
          btn_shown = false;
        }
      });
  	}
  
  
  	/*
	var selected_c;
    $('#currency-selector a').click(function() {
     	selected_c = $(this).attr("data-select");
      	console.log(selected_c);
      	$('#currencies').val(selected_c).change();
     	//$('#currency-picker-toggle option[value="'+selected_c+'"]').attr('selected','selected');
    });
  	
    function populateDropdown() {
    	//make new arrays that will hold values and text for new elements
      	var g_vals = new Array();
      	var this_val;
      	var this_text;
      	var new_item;
      	var g_text = new Array();
      	$('.goog-te-combo option').each(function(){
        	g_vals.push($(this).attr('value')); 
          	g_text.push($(this).text());
        });
      	g_vals.shift();
      	g_text.shift();
      	$('#language-selector').html('<li><a class="notranslate" tabindex="-1" data-select="en" href="#">English</a></li>');
        var j = g_vals.length;
        for(i = 0; i < j; i++){
          	this_val = g_vals[i];
            this_text = g_text[i];
          	new_item = '<li><a href="#" data-select="'+this_val+'" tabindex="-1">'+this_text+'</a></li>';
            $('#language-selector').append(new_item);
        };
    }
  	function triggerHtmlEvent(element, eventName) {
    var event;
    if(document.createEvent) {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, true, true);
        element.dispatchEvent(event);
    } else {
        event = document.createEventObject();
        event.eventType = eventName;
        element.fireEvent('on' + event.eventType, event);
    } } 
  
  	function changeGoogleTranslate() {
    if ($('.goog-te-combo option:first-child').text().length > 0) {
    	populateDropdown();
    } else {
    	setTimeout(changeGoogleTranslate, 50);
    	}
    }
    changeGoogleTranslate();
    
    $('#language-selector').on('click','a', function(){
      	var this_text = $(this).text();
    	var this_lang = $(this).attr('data-select');
      	console.log(this_lang);
      	$('.goog-te-combo').attr('id','google-translate').val(this_lang);
        $('#current-lang').text(this_text);
        var selectObject = document.getElementById("google-translate"); 
      	triggerHtmlEvent(selectObject, 'change');
      	populateDropdown();
    });
	*/
   
});
    

